/* Auto-generated from graham.care progress pages — run scripts/build-progress-data.mjs to refresh */

import type { ProgressCarouselItem } from '../components/ProgressStageCarousel';
import { BROOMFIELD_PROGRESS_STAGES } from './broomfieldProgressGallery';
import { BROOMFIELD_SUPPLEMENTAL_STAGES } from './broomfieldSupplementalStages';
import { SOUTHLANDS_PROGRESS_STAGES } from './southlandsProgressGallery';
import { SOUTHLANDS_SUPPLEMENTAL_STAGES } from './southlandsSupplementalStages';
import { withSouthlandsBlurbs } from './southlandsProgressBlurbs';
import { WHITSTABLE_HEIGHTS_PROGRESS_STAGES } from './whitstableHeightsProgressGallery';
import { PEMBURY_PROGRESS_STAGES } from './pemburyProgressGallery';
import { withBroomfieldBlurbs } from './broomfieldProgressBlurbs';

export type ProgressStage = {
  date: string;
  title: string;
  image?: string;
  body?: string;
  items?: ProgressCarouselItem[];
};

export type DevelopmentProgressTimeline = {
  slug: string;
  developmentName: string;
  location: string;
  stages: ProgressStage[];
};

export const DEVELOPMENT_PROGRESS_TIMELINES: Record<string, DevelopmentProgressTimeline> = {
  "broomfield": {
    "slug": "broomfield",
    "developmentName": "Broomfield House",
    "location": "Chelmsford",
    "stages": [
      {
        "date": "July 2025",
        "title": "Commencement of Masonry",
        "image": "https://graham.care/wp-content/uploads/2025/08/Chelmsforddevs-09.07.252-scaled.jpg"
      },
      {
        "date": "June 2025",
        "title": "Drone Footage",
        "image": "https://graham.care/wp-content/uploads/2025/08/Chelmsforddevs-25.06.251-scaled.jpg"
      },
      {
        "date": "June 2025",
        "title": "Roof Level Over Retail",
        "image": "https://graham.care/wp-content/uploads/2025/08/Chelmsforddevs-11.06.252-scaled.jpg"
      },
      {
        "date": "May 2025",
        "title": "Striking Formwork",
        "image": "https://graham.care/wp-content/uploads/2025/08/Chelmsforddevs-14.05.251-scaled.jpg"
      },
      {
        "date": "April 2025",
        "title": "Concrete Framing",
        "image": "https://graham.care/wp-content/uploads/2025/07/Chelmsforddevs-24.04.153-scaled.jpg"
      },
      {
        "date": "March 2025",
        "title": "Crane and Concrete Framing Start",
        "image": "https://graham.care/wp-content/uploads/2025/07/chelmsforddevs-23.03.117-scaled.jpg"
      },
      {
        "date": "January 2025",
        "title": "Hydrotherapy Pool Rebar",
        "image": "https://graham.care/wp-content/uploads/2025/07/Chelmsforddevs-25.01.154-scaled.jpg"
      },
      {
        "date": "December 2024",
        "title": "Basement Works",
        "image": "https://graham.care/wp-content/uploads/2025/07/Chelmsforddevs-24.12.114-scaled.jpg"
      },
      {
        "date": "November 2024",
        "title": "Breaking Ground",
        "image": "https://graham.care/wp-content/uploads/2025/07/Chelmsforddevs-24.11.132-scaled.jpg"
      },
      {
        "date": "October 2024",
        "title": "Pre-Contract Meeting with Natta",
        "image": "https://graham.care/wp-content/uploads/2025/07/Chelmsforddevs-24.10.01-scaled.jpg"
      }
    ]
  },
  "southlands": {
    "slug": "southlands",
    "developmentName": "Southlands House",
    "location": "Sittingbourne",
    "stages": [
      {
        "date": "June 2025",
        "title": "Contract Start",
        "image": "https://graham.care/wp-content/uploads/2025/07/southlandsdevs-24.04.305-scaled.jpg"
      },
      {
        "date": "April 2025",
        "title": "Final Reptile Mitigation",
        "image": "https://graham.care/wp-content/uploads/2025/07/southlandsdevs-25.03.263-scaled.jpg"
      },
      {
        "date": "March 2025",
        "title": "Enabling and Drainage",
        "image": "https://graham.care/wp-content/uploads/2025/07/southlandsdevs-25.01.2910-scaled.jpg"
      },
      {
        "date": "January 2025",
        "title": "Demolition",
        "image": "https://graham.care/wp-content/uploads/2025/07/20240624_121729-scaled.jpg"
      },
      {
        "date": "June 2024",
        "title": "Site Overview: Pre-Construction",
        "image": "https://graham.care/wp-content/uploads/2025/07/20240624_121729-scaled.jpg"
      }
    ]
  },
  "harpwood": {
    "slug": "harpwood",
    "developmentName": "Harpwood House",
    "location": "Sevenoaks",
    "stages": [
      {
        "date": "August 2023",
        "title": "28th March 2023",
        "image": "https://graham.care/wp-content/uploads/2023/08/IMG_6220.jpg"
      },
      {
        "date": "July 2023",
        "title": "27th July 2023",
        "image": "https://graham.care/wp-content/uploads/2023/08/IMG_5742.jpg"
      },
      {
        "date": "June 2023",
        "title": "22nd June 2023",
        "image": "https://graham.care/wp-content/uploads/2023/08/IMG_2948.jpg"
      },
      {
        "date": "February 2023",
        "title": "20th February 2023",
        "image": "https://graham.care/wp-content/uploads/2023/08/IMG_0920.jpg"
      },
      {
        "date": "October 2022",
        "title": "27th October 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_9994.jpg"
      },
      {
        "date": "August 2022",
        "title": "25 August 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_9537.jpg"
      },
      {
        "date": "July 2022",
        "title": "28 July 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_8918.jpg"
      },
      {
        "date": "June 2022",
        "title": "30 June 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_8259.jpg"
      },
      {
        "date": "May 2022",
        "title": "26 May 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_7766.jpg"
      },
      {
        "date": "April 2022",
        "title": "27 April 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_7131.jpg"
      },
      {
        "date": "March 2022",
        "title": "24 March 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_6589.jpg"
      },
      {
        "date": "February 2022",
        "title": "24 February 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_5942.jpg"
      },
      {
        "date": "January 2022",
        "title": "20 January 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_5350.jpg"
      },
      {
        "date": "December 2021",
        "title": "16 December 2021",
        "image": "https://graham.care/wp-content/uploads/2021/12/IMG_5008.jpg"
      },
      {
        "date": "November 2021",
        "title": "18 November 2021",
        "image": "https://graham.care/wp-content/uploads/2021/12/IMG_4387.jpg"
      }
    ]
  },
  "whitstable-phase-1": {
    "slug": "whitstable-phase-1",
    "developmentName": "Whitstable House Phase 1",
    "location": "Whitstable",
    "stages": [
      {
        "date": "March 2023",
        "title": "21 March 2023",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_5833.jpg"
      },
      {
        "date": "January 2022",
        "title": "19 January 2022",
        "image": "https://graham.care/wp-content/uploads/2022/09/IMG_5328.jpg"
      },
      {
        "date": "December 2021",
        "title": "15 December 2021",
        "image": "https://graham.care/wp-content/uploads/2021/12/IMG_4832.jpg"
      },
      {
        "date": "November 2021",
        "title": "17 November 2021",
        "image": "https://graham.care/wp-content/uploads/2021/12/IMG_4248.jpg"
      }
    ]
  },
  "pembury": {
    "slug": "pembury",
    "developmentName": "Pembury House",
    "location": "Tunbridge Wells",
    "stages": [
      {
        "date": "Planning",
        "title": "Scheme design",
        "image": "https://graham.care/wp-content/uploads/2024/10/Pembury-House-Cornford-Crt-CGI02B-scaled.jpg",
        "body": "Visualisation of the proposed Pembury House development at Tunbridge Wells."
      }
    ]
  },
  "whitstable-heights": {
    "slug": "whitstable-heights",
    "developmentName": "Whitstable Heights",
    "location": "Whitstable",
    "stages": [
      {
        "date": "Planning approved",
        "title": "Whitstable Heights — Phase 2",
        "image": "https://graham.care/wp-content/uploads/2025/10/Whitstable-heights-CGI-1-scaled.jpg",
        "body": "102-suite acute care home forming Phase 2 of the Estuary View development, programmed to follow completion of the Integrated Community Health Centre."
      }
    ]
  },
  "rodwell": {
    "slug": "rodwell",
    "developmentName": "Rodwell House",
    "location": "Addlestone",
    "stages": [
      {
        "date": "Complete",
        "title": "Rodwell House, Addlestone",
        "image": "https://graham.care/wp-content/uploads/2022/07/chelmsford-thumb.jpg",
        "body": "Rodwell House is an established Graham Care home providing nursing-led care in Addlestone, Surrey."
      }
    ]
  }
};

export function getProgressTimeline(slug: string): DevelopmentProgressTimeline | undefined {
  if (slug === 'broomfield') {
    return {
      slug: 'broomfield',
      developmentName: 'Broomfield House',
      location: 'Chelmsford',
      stages: withBroomfieldBlurbs([
        ...BROOMFIELD_SUPPLEMENTAL_STAGES,
        ...BROOMFIELD_PROGRESS_STAGES,
      ]),
    };
  }
  if (slug === 'southlands') {
    return {
      slug: 'southlands',
      developmentName: 'Southlands House',
      location: 'Sittingbourne',
      stages: withSouthlandsBlurbs([
        ...SOUTHLANDS_SUPPLEMENTAL_STAGES,
        ...SOUTHLANDS_PROGRESS_STAGES,
      ]),
    };
  }
  if (slug === 'whitstable-heights') {
    return {
      slug: 'whitstable-heights',
      developmentName: 'Whitstable Heights',
      location: 'Whitstable',
      stages: WHITSTABLE_HEIGHTS_PROGRESS_STAGES,
    };
  }
  if (slug === 'pembury') {
    return {
      slug: 'pembury',
      developmentName: 'Pembury House',
      location: 'Tunbridge Wells',
      stages: PEMBURY_PROGRESS_STAGES,
    };
  }
  return DEVELOPMENT_PROGRESS_TIMELINES[slug];
}

export function progressTimelinePath(slug: string): string {
  return `/developments/progress/${slug}`;
}
